var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowDown1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4075 7.74375C14.0825 7.41875 13.5575 7.41875 13.2325 7.74375L9.99921 10.9771L6.76588 7.74375C6.44088 7.41875 5.91588 7.41875 5.59088 7.74375C5.26588 8.06875 5.26588 8.59375 5.59088 8.91875L9.41588 12.7437C9.74088 13.0687 10.2659 13.0687 10.5909 12.7437L14.4159 8.91875C14.7325 8.60208 14.7325 8.06875 14.4075 7.74375Z",
    fill: "#01908D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown1);
export default __webpack_public_path__ + "static/media/icon_arrow_down_1.2f2f63e14dec9df55c523cfb6b74c339.svg";
export { ForwardRef as ReactComponent };